<div class="sidebar sidebar-2">
    <!-- Categories Start -->
    <div class="sidebar-widget widget-categories">
        <h5 class="widget-title"> Latest Services </h5>
        <ul class="sidebar-widget-list">
            <!-- Data -->
            <li *ngFor="let item of serviceblock"> <a routerLink="/service-details/{{item.id}}"> {{item.title}} <i class="far fa-chevron-right"></i> </a> </li>
            <!-- Data -->
        </ul>
    </div>
    <!-- Categories End -->
    <div class="sidebar-widget p-0">
        <div class="blockquote d-block border-0">
            <h5 class="widget-title text-white">Request a Quote</h5>
            <div class="sigma_blockquote-content m-0">
                <p class="fs-14">In the US, camping may be traced to William Henry Harrison Murray 1869 publication of Camp-Life.</p>
            </div>
            <a routerLink="/contact" class="sigma_btn-custom">Get a Quote</a>
        </div>
    </div>
    <!-- Categories Start -->
    <div class="sidebar-widget widget-categories">
        <h5 class="widget-title"> Project Assets </h5>
        <ul class="sidebar-widget-list">
            <li> <a href="#" class="justify-content-start"> <i class="far fa-file-pdf mr-3"></i> Download PDF </a> </li>
            <li> <a href="#" class="justify-content-start"> <i class="far fa-file-pdf mr-3"></i> Download Documents </a> </li>
            <li> <a href="#" class="justify-content-start"> <i class="far fa-file-pdf mr-3"></i> Download Brochures </a> </li>
        </ul>
    </div>
    <!-- Categories End -->
    <div class="sidebar-widget widget-ad p-0 border-0">
        <a href="#">
            <img src="assets/img/service/details/ad.jpg" alt="ad">
            <div>
                <span>Add a Custom Text</span>
                Add Banner here
            </div>
        </a>
    </div>
</div>